import { DOCUMENT } from '@angular/common';
import { ElementRef, Injectable, type Renderer2, RendererFactory2, inject } from '@angular/core';

@Injectable()
export class MeasureService {
  private element = inject(ElementRef);
  private rendererFactory = inject(RendererFactory2);
  private renderer: Renderer2; // = inject(Renderer2);

  private hostElement: HTMLElement;
  private hiddenSpan: HTMLSpanElement;

  private useCache = false;
  private sizeCache = new Map<string, number>();

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);

    // create a hidden span for measuring text width
    this.hiddenSpan = this.renderer.createElement('span');
    this.renderer.setStyle(this.hiddenSpan, 'visibility', 'hidden');
    this.renderer.setStyle(this.hiddenSpan, 'position', 'absolute');
    this.renderer.setStyle(this.hiddenSpan, 'white-space', 'nowrap');
    this.renderer.setStyle(this.hiddenSpan, 'font', 'inherit');

    // attach to host element that injected the service
    this.attachToHost();
  }

  public setUseCache = (useCache: boolean) => {
    this.useCache = useCache;
  };

  public attachToHost = () => {
    this.attachToElement(this.element.nativeElement);
  };

  public attachToElement = (element: HTMLElement) => {
    // detach from previous host element
    if (this.hostElement) {
      this.detach();
    }

    this.hostElement = element;
    this.hostElement.appendChild(this.hiddenSpan);
  };

  public detach = () => {
    this.hostElement?.removeChild(this.hiddenSpan);
    this.hostElement = undefined;
  };

  public calcTextWidth = (text: string, element?: HTMLElement) => {
    if (this.useCache && this.sizeCache.has(text)) {
      return this.sizeCache.get(text);
    }

    if (element) {
      this.detach();
      element.appendChild(this.hiddenSpan);
    }

    this.hiddenSpan.textContent = text ?? ' ';
    const { width, height } = this.hiddenSpan.getBoundingClientRect();
    const textWidth = Math.ceil(width); // this.hiddenSpan.offsetWidth;

    this.sizeCache.set(text, textWidth);

    if (element) element.removeChild(this.hiddenSpan);

    return textWidth;
  };
}
